import React from 'react';
import propTypes from 'prop-types';
import Modal from 'tailwind-components/Modal/Modal';

const wrapperStyle = {
  width: '100%',
  height: 'min(75vh, calc(100vh - 300px))',
  minHeight: 0,
  display: 'flex',
  alignItems: 'stretch',
  justifyContent: 'center'
};

const iframeStyle = {
  width: '100%',
  height: '100%',
  border: 'none'
};

export default function SunshineZohoFormModal({
  data,
  onClose,
  allowCamera = false,
  className = ''
}) {
  const { title, src, iframeTitle } = data;
  return (
    <Modal
      active
      size='large'
      closeModal={onClose}
      title={title}
      className={className}
    >
      <div style={wrapperStyle}>
        <iframe
          title={iframeTitle}
          src={src}
          style={iframeStyle}
          allow={allowCamera ? 'camera; microphone' : undefined}
        />
      </div>
    </Modal>
  );
}

SunshineZohoFormModal.propTypes = {
  data: propTypes.shape({
    title: propTypes.string.isRequired,
    src: propTypes.string.isRequired,
    iframeTitle: propTypes.string.isRequired
  }).isRequired,
  onClose: propTypes.func.isRequired,
  allowCamera: propTypes.bool,
  className: propTypes.string
};
